export default "/_next/static/images/patrick-mccarthy-ba96ffdc99a57b9ea12f71612e6d1f46.png";